import React from 'react'
import CookieNotice from './vendor-forks/cookie-notice'
import { insertAnalyticScripts } from './analytics'
import {
  GATSBY_GOOGLE_ANALYTICS_COOKIE_NAME,
  GATSBY_GOOGLE_TAG_MANAGER_COOKIE_NAME,
} from '../lib/global'
import * as styles from './cookie-banner.module.css'

const CookieBanner = () => {
  // If the cookie banner is accepted, insert the analytics scripts.
  const onAccept = () => {
    insertAnalyticScripts()
  }

  return (
    <CookieNotice
      backgroundClasses={styles.bannerWrapper}
      wrapperClasses={styles.buttonsWrapper}
      buttonWrapperClasses={styles.buttonsInnerWrapper}
      acceptButtonClasses={styles.acceptButton}
      declineButtonClasses={styles.declineButton}
      personalizeButtonEnable={false}
      cookies={[
        {
          name: GATSBY_GOOGLE_ANALYTICS_COOKIE_NAME,
          editable: true,
          default: true,
        },
        {
          name: GATSBY_GOOGLE_TAG_MANAGER_COOKIE_NAME,
          editable: true,
          default: true,
        },
      ]}
      onAccept={onAccept}
    >
      <div className={styles.descriptionWrapper}>
        <div className={styles.title}>This websites uses cookies.</div>
        <div className={styles.description}>
          We use cookies to make the site work better and see how you interact
          with it. We will only use cookies if you allow us to do so by clicking
          on &quot;Accept Cookies&quot;.
        </div>
      </div>
    </CookieNotice>
  )
}

export default CookieBanner
